import ManageOrders from "../../views/WholesalerPortal/WholesalerOrders/ManageOrders/ManageOrders";
import OrderFulfillment from "../../views/WholesalerPortal/WholesalerOrders/OrderFulfillment/OrderFulfillment";
import ReturnsAndRefunds from "../../views/WholesalerPortal/WholesalerOrders/ReturnsAndRefunds/ReturnsAndRefunds";
import OrderAnalytics from "../../views/WholesalerPortal/WholesalerOrders/OrderAnalytics/OrderAnalytics";
import ManageProducts from "../../views/WholesalerPortal/WholesalerProducts/ManageProducts/ManageProducts";
import AddProduct from "../../views/WholesalerPortal/WholesalerProducts/AddProduct/AddProduct";
import CategoryManagement from "../../views/WholesalerPortal/WholesalerProducts/CategoryManagement/CategoryManagement";
import BrandManagement from "../../views/WholesalerPortal/WholesalerProducts/BrandManagement/BrandManagement";
import AddBrandInformation from "../../components/WholesalerComponents/BrandManagementTabs/AddBrandInformation/AddBrandInformation";
import WholesalerDashboard from "../../views/WholesalerPortal/WholesalerDashboard/WholesalerDashboard";
import Reviews from "../../views/WholesalerPortal/WholesalerCustomerEngage/Reviews/Reviews";
import PurchaseHistory from "../../views/WholesalerPortal/WholesalerCustomerEngage/PurchaseHistory/PurchaseHistory";
import WholesalerFBM from "../../views/WholesalerPortal/WholesalerFBM/WholesalerFBM";
import WholesalerFBMDashboard from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMDashboard/WholesalerFBMDashboard";
import ManagePlatformProducts from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMProducts/ManagePlatformProducts/ManagePlatformProducts";
import ManageFulfillmentSKU from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMProducts/ManageFulfillmentSKU/ManageFulfillmentSKU";
import OrderManagement from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMOrders/SentToWarehouse/OrderManagement/OrderManagement";
import ReverseOrderManagement from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMOrders/BackFromWarehouse/ReverseOrderManagement/ReverseOrderManagement";
import CreateReturnShipment from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMOrders/BackFromWarehouse/CreateReturnShipment/CreateReturnShipment";
import TrackShipmentBack from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMOrders/BackFromWarehouse/TrackShipmentBack/TrackShipmentBack";
import ReceivedInventoryBack from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMOrders/BackFromWarehouse/ReceivedInventoryBack/ReceivedInventoryBack";
import InventoryDiscrepanciesBack from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMOrders/BackFromWarehouse/InventoryDiscrepanciesBack/InventoryDiscrepanciesBack";
import SalesReport from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMReports/SalesReport/SalesReport";
import InventoryReport from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMReports/InventoryReport/InventoryReport";
import ExpiryDateReport from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMReports/ExpiryDateReport/ExpiryDateReport";
import InventoryAging from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMReports/InventoryAging/InventoryAging";
import FinancialReport from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMReports/FinancialReport/FinancialReport";
import InventoryReconciliation from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMReports/InventoryReconciliation/InventoryReconciliation";
import WholesalerFBMScheduleDropOff from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMScheduleDropOff/WholesalerFBMScheduleDropOff";
import CreateNewShipment from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMOrders/SentToWarehouse/CreateNewShipment/CreateNewShipment";
import TrackShipment from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMOrders/SentToWarehouse/TrackShipment/TrackShipment";
import ReceivedInventory from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMOrders/SentToWarehouse/ReceivedInventory/ReceivedInventory";
import InventoryDiscrepancies from "../../views/WholesalerPortal/WholesalerFBMPortal/WholesalerFBMOrders/SentToWarehouse/InventoryDiscrepancies/InventoryDiscrepancies";
import WholesalerCampaigns from "../../views/WholesalerPortal/WholesalerMarketingOptions/Campaigns/Campaigns";
import WholesalerViewCampaign from "../../views/WholesalerPortal/WholesalerMarketingOptions/Campaigns/ViewCampaign/ViewCampaign";
import WholesalerCoupons from "../../views/WholesalerPortal/WholesalerMarketingOptions/Coupons/Coupons";
import EditCouponDetails from "../../views/WholesalerPortal/WholesalerMarketingOptions/Coupons/EditCouponDetails/EditCouponDetails";
import WholesalerProductSubmission from "../../views/WholesalerPortal/WholesalerMarketingOptions/Campaigns/ProductSubmission/ProductSubmission";
import WholesalerVouchers from "../../views/WholesalerPortal/WholesalerMarketingOptions/Vouchers/Vouchers";
import WholesalerVoucherDetails from "../../views/WholesalerPortal/WholesalerMarketingOptions/Vouchers/VoucherDetails/VoucherDetails";
import Overview from "../../views/WholesalerPortal/WholesalerAdvertisement/Overview/Overview";
import Management from "../../views/WholesalerPortal/WholesalerAdvertisement/Management/Management";
import AdPerformance from "../../views/WholesalerPortal/WholesalerAdvertisement/AdPerformance/AdPerformance";
import Creation from "../../views/WholesalerPortal/WholesalerAdvertisement/Creation/Creation";
import SponsoredProducts from "../../views/WholesalerPortal/WholesalerAdvertisement/SponsoredProducts/SponsoredProducts";
import SponsoredBrands from "../../views/WholesalerPortal/WholesalerAdvertisement/SponsoredBrands/SponsoredBrands";
import SponsoredDisplay from "../../views/WholesalerPortal/WholesalerAdvertisement/SponsoredDisplay/SponsoredDisplay";
import BannerAds from "../../views/WholesalerPortal/WholesalerAdvertisement/BannerAds/BannerAds";
import FinanceOverview from "../../views/WholesalerPortal/WholesalerFinance/FinanceOverview/FinanceOverview";
import TransactionHistory from "../../views/WholesalerPortal/WholesalerFinance/TransactionHistory/TransactionHistory";
import PaymentInfo from "../../views/WholesalerPortal/WholesalerFinance/PaymentInfo/PaymentInfo";
import FeeBreakdown from "../../views/WholesalerPortal/WholesalerFinance/FeeBreakdown/FeeBreakdown";
import SellerFinancing from "../../views/WholesalerPortal/WholesalerFinance/SellerFinancing/SellerFinancing";
import WholesalerReportsAnalytics from "../../views/WholesalerPortal/WholesalerReportsAnalytics/WholesalerReportsAnalytics";
import WholesalerPolicies from "../../views/WholesalerPortal/WholesalerCompliance/Policies/Policies";
import WholesalerProductAdvisory from "../../views/WholesalerPortal/WholesalerCompliance/ProductAdvisory/ProductAdvisory";
import PersonalizedRecommendations from "../../components/WholesalerComponents/PersonalizedRecommendations/PersonalizedRecommendations";
import DocumentTemplate from "../../views/WholesalerPortal/WholesalerOtherResources/DocumentTemplate/DocumentTemplate";
import PackagingMaterial from "../../views/WholesalerPortal/WholesalerOtherResources/PackagingMaterial/PackagingMaterial";
import Services from "../../views/WholesalerPortal/WholesalerOtherResources/Services/Services";
import Profile from "../../views/WholesalerPortal/WholesalerSettings/Profile/Profile";
import Security from "../../views/WholesalerPortal/WholesalerSettings/Security/Security";
import Commissions from "../../views/WholesalerPortal/WholesalerSettings/Commissions/Commissions";
import Notification from "../../views/WholesalerPortal/WholesalerSettings/Notification/Notification";
import User from "../../views/WholesalerPortal/WholesalerSettings/User/User";
import ChatSetting from "../../views/WholesalerPortal/WholesalerSettings/ChatSetting/ChatSetting";
import CRM from "../../views/WholesalerPortal/WholesalerCustomerEngage/CRM/CRM";
import VIPCustomers from "../../views/WholesalerPortal/WholesalerCustomerEngage/VipCustomers/VipCustomers";
import StoreSetting from "../../views/WholesalerPortal/WholesalerSettings/StoreSetting/StoreSetting";
import CreateStorePage from "../../views/WholesalerPortal/WholesalerSettings/StoreSetting/CreateStorePage/CreateStorePage";
import CreateNewTheme from "../../views/WholesalerPortal/WholesalerSettings/StoreSetting/CreateNewTheme/CreateNewTheme";
import CreateCustomPage from "../../views/WholesalerPortal/WholesalerSettings/StoreSetting/CreateCustomPage/CreateCustomPage";
import StoreThemePreview from "../../views/WholesalerPortal/WholesalerSettings/StoreSetting/StoreThemePreview/StoreThemePreview";

const wholesalerRoutes = [
  {
    path: "/dashboard",
    element: <WholesalerDashboard />,
    meta: {
      layout: "vertical",
    },
  },
  {
    path: "/products",
    meta: {
      layout: "vertical",
    },
    children: [
      {
        path: "manage",
        element: <ManageProducts />,
      },
      {
        path: "add",
        element: <AddProduct />,
      },
      {
        path: "category",
        element: <CategoryManagement />,
      },
      {
        path: "brand",
        element: <BrandManagement />,
      },
      {
        path: "brand/edit",
        element: <AddBrandInformation />,
      },
    ],
  },
  {
    path: "/orders",
    meta: {
      layout: "vertical",
    },
    children: [
      {
        path: "manage",
        element: <ManageOrders />,
      },
      {
        path: "fulfillment",
        element: <OrderFulfillment />,
      },
      {
        path: "returns-and-refunds",
        element: <ReturnsAndRefunds />,
      },
      {
        path: "order-analytics",
        element: <OrderAnalytics />,
      },
    ],
  },
  {
    path: "/fbmregister",
    element: <WholesalerFBM />,
    meta: {
      layout: "vertical",
    },
  },
  {
    path: "/customer-engage",
    meta: {
      layout: "vertical",
    },
    children: [
      {
        path: "customer-relationship-management",
        element: <CRM />,
      },
      {
        path: "reviews",
        element: <Reviews />,
      },
      {
        path: "vip-customers",
        element: <VIPCustomers />,
      },
      {
        path: "purchase-history",
        element: <PurchaseHistory />,
      },
    ],
  },
  {
    path: "/marketing-options",
    meta: {
      layout: "vertical",
    },
    children: [
      {
        path: "campaigns",
        element: <WholesalerCampaigns />,
      },
      {
        path: "campaigns/view",
        element: <WholesalerViewCampaign />,
      },
      {
        path: "campaigns/add-product",
        element: <WholesalerProductSubmission />,
      },
      {
        path: "coupons",
        element: <WholesalerCoupons />,
      },
      {
        path: "edit-coupon",
        element: <EditCouponDetails />,
      },
      {
        path: "vouchers",
        element: <WholesalerVouchers />,
      },
      {
        path: "vouchers/detail",
        element: <WholesalerVoucherDetails />,
      },
    ],
  },
  {
    path: "/advertisement",
    meta: {
      layout: "vertical",
    },
    children: [
      {
        path: "overview",
        element: <Overview />,
      },
      {
        path: "creation",
        element: <Creation />,
      },
      {
        path: "creation/sponsored-products",
        element: <SponsoredProducts />,
      },
      {
        path: "creation/sponsored-brands",
        element: <SponsoredBrands />,
      },
      {
        path: "creation/sponsored-display",
        element: <SponsoredDisplay />,
      },
      {
        path: "creation/sponsored-banner-ads",
        element: <BannerAds />,
      },
      {
        path: "management",
        element: <Management />,
      },
      {
        path: "ad-performance",
        element: <AdPerformance />,
      },
    ],
  },
  {
    path: "/finance",
    meta: {
      layout: "vertical",
    },
    children: [
      {
        path: "overview",
        element: <FinanceOverview />,
      },
      {
        path: "transaction-history",
        element: <TransactionHistory />,
      },
      {
        path: "payment-info",
        element: <PaymentInfo />,
      },
      {
        path: "fee-breakdown",
        element: <FeeBreakdown />,
      },
      {
        path: "seller-financing",
        element: <SellerFinancing />,
      },
    ],
  },
  {
    path: "/analytics",
    element: <WholesalerReportsAnalytics />,
    meta: {
      layout: "vertical",
    },
  },
  {
    path: "/compliance",
    meta: {
      layout: "vertical",
    },
    children: [
      {
        path: "policies",
        element: <WholesalerPolicies />,
      },
      {
        path: "productadvisory",
        element: <WholesalerProductAdvisory />,
      },
      {
        path: "productadvisory/recommendations",
        element: <PersonalizedRecommendations />,
      },
    ],
  },
  {
    path: "/other-resources",
    meta: {
      layout: "vertical",
    },
    children: [
      {
        path: "document-template",
        element: <DocumentTemplate />,
      },
      {
        path: "services",
        element: <Services />,
      },
      {
        path: "packaging-material",
        element: <PackagingMaterial />,
      },
    ],
  },
  {
    path: "/settings",
    meta: {
      layout: "vertical",
    },
    children: [
      {
        path: "profile",
        element: <Profile />,
      },
      {
        path: "security",
        element: <Security />,
      },
      {
        path: "commission",
        element: <Commissions />,
      },
      {
        path: "notification",
        element: <Notification />,
      },
      {
        path: "user",
        element: <User />,
      },
      {
        path: "chat-setting",
        element: <ChatSetting />,
      },
      {
        path: "store-setting",
        element: <StoreSetting />,
      },
      {
        path: "create-store-page",
        element: <CreateStorePage />,
      },
      {
        path: "create-new-theme",
        element: <CreateNewTheme />,
      },
      {
        path: "create-custom-page",
        element: <CreateCustomPage />,
      },
      {
        path: "store-theme-preview",
        element: <StoreThemePreview />,
      },
    ],
  },



  // ---------------------------------- FBM Dashboard Sidebar Routes --------------------------------------
  {
    path: "/fbm/dashboard",
    element: <WholesalerFBMDashboard />,
    meta: {
      layout: "vertical",
    },
  },
  {
    path: "/fbm/products",
    meta: {
      layout: "vertical",
    },
    children: [
      {
        path: "manageproducts",
        element: <ManagePlatformProducts />,
      },
      {
        path: "managesku",
        element: <ManageFulfillmentSKU />,
      },
    ],
  },
  {
    path: "/fbm/orders",
    meta: {
      layout: "vertical",
    },
    children: [
      {
        path: "sent",
        children: [
          {
            path: "management",
            element: <OrderManagement />,
          },
          {
            path: "newshipment",
            element: <CreateNewShipment />,
          },
          {
            path: "trackshipment",
            element: <TrackShipment />,
          },
          {
            path: "receivedinventory",
            element: <ReceivedInventory />,
          },
          {
            path: "inventorydiscrepancies",
            element: <InventoryDiscrepancies />,
          },
        ],
      },
      {
        path: "back",
        children: [
          {
            path: "reverseorder",
            element: <ReverseOrderManagement />,
          },
          {
            path: "returnshipment",
            element: <CreateReturnShipment />,
          },
          {
            path: "trackshipment",
            element: <TrackShipmentBack />,
          },
          {
            path: "receivedinventory",
            element: <ReceivedInventoryBack />,
          },
          {
            path: "inventorydiscrepancies",
            element: <InventoryDiscrepanciesBack />,
          },
        ],
      },
    ],
  },
  {
    path: "/fbm/schedule",
    element: <WholesalerFBMScheduleDropOff />,
    meta: {
      layout: "vertical",
    },
  },
  {
    path: "/fbm/reports",
    meta: {
      layout: "vertical",
    },
    children: [
      {
        path: "sales",
        element: <SalesReport />,
      },
      {
        path: "inventory",
        element: <InventoryReport />,
      },
      {
        path: "expirydate",
        element: <ExpiryDateReport />,
      },
      {
        path: "inventoryaging",
        element: <InventoryAging />,
      },
      {
        path: "inventoryreconciliation",
        element: <InventoryReconciliation />,
      },
      {
        path: "financial",
        element: <FinancialReport />,
      },
    ],
  },
];

export default wholesalerRoutes;